module.exports = __webpack_public_path__ + "static/media/policy_select_icon2.445677b3.png";